import axios, { AxiosResponse } from '../../node_modules/axios/index';
import { getApiUrl } from '../constants/api';

export interface SearchUIStyles {
  borderRadius?: string;
  searchIconColor?: string;
  searchPlaceHolder?: string;
  searchPlaceHolderEn?: string;
  voiceSearchIconColor?: string;
  voiceSearchBackgroundColor?: string;
  enableEnglishPrices?: boolean;
  priceColor?: string;
  isDynamicFiltersEnabled?: boolean;
  allowedDynamicFilters?: string[];
  dynamicFiltersPrimaryColor?: string;
  dynamicFiltersCountColor?: string;
  discountedPriceColor?: string;
  isVoiceSearchEnabled?: boolean;
  searchResultsTitleColor?: string;
}

export interface Settings {
  isSearchPageEnabled: boolean;
  resultsNumberOfColumns: 'one-column' | 'two-columns' | 'three-columns';
  productsPerColumn: number;
  showProductImage: boolean;
  showProductPrice: boolean;
  showOutOfStockProducts: boolean;
  showDiscounts: boolean;
  suggestSimilarKeywords: boolean;
  suggestSimilarProducts: boolean;
  noResultsText: string;
  isImageSearchEnabled: boolean;
  uiStyles: SearchUIStyles;
}

export async function getSearchBarSettings(storyId: string, storeType: string) {
  const response: AxiosResponse<Settings> = await axios.get(
    `${getApiUrl(
      `${storyId}`,
    )}/stores/${storyId}/search/settings?storeType=${storeType}`,
  );
  return response.data;
}
